import ProductStore from '../stores/product-store'
import ImageStore from '../stores/image-store'
import Config from '../config'
import OpeProduct from '../objects/opeproduct'
import SelectorActions from '../actions/selector-actions'


var ProductCalculations = {};

/**
 * Figure out which product is the best fit for a given image size
 * @param  {int}
 * @param  {int}
 * @param  {string} (optional)
 * @param  {int} (optional)
 * @return {object}
 */
ProductCalculations.autoSelectProduct = function (imageWidth, imageHeight, selectedProductId, selectedProductPrintLenght) {
    //If both of these are supplied, then no need to calculate anything because the product is already decided
    if (selectedProductId !== "undefined" && selectedProductPrintLenght !== "undefined") {
        var product = ProductStore.getProductById(selectedProductId);
        if (!(product instanceof OpeProduct)) {
            throw new Error("Cannot auto select products based on pap id: " + selectedProductId + " because the product does not exist. This is a likely a misconfiguration of the editor. Please use another value for autoselectproduct");
        }
        return {
            productId: selectedProductId,
            productWidth: selectedProductPrintLenght,
            productHeight: product.getHeight(),
            matchRatioDiff: 0
        };
    }

    //Calculate image ratio
    var imageRatio;
    if (imageHeight >= imageWidth) {
        imageRatio = imageHeight / imageWidth;
    } else {
        imageRatio = imageWidth / imageHeight;
    }

    //Get a list of products to run through to find the best match
    var productList = [];
    if (selectedProductId !== "undefined") {
        var product = ProductStore.getProductById(selectedProductId);
        if (!(product instanceof OpeProduct)) {
            throw new Error("Cannot auto select products based on pap id: " + selectedProductId + " because the product does not exist. This is a likeley a misconfiguration of the editor in the init script. Please use another value for autoselectproduct");
        }
        productList.push(product);
    } else {
        var storeProducts = ProductStore.getProducts();
        for (var id in storeProducts) {
            if (storeProducts.hasOwnProperty(id)) {
                productList.push(storeProducts[id]);
            }
        }
    }
    //Run through products to find the best matching product for the image size
    var bestMatchProductId;
    var bestMatchProductPrintLength;
    var bestMatchRatioDiff = 10000;
    var bestMatchProductHeight = 0;

    outerLoop:
        for (var i = 0; i < productList.length; i++) {
            var productHeight = productList[i].getHeight();
            for (var productWidth in productList[i].getWidthList()) {
                var productRatio;
                if (productHeight >= productWidth) {
                    productRatio = productHeight / productWidth;
                } else {
                    productRatio = productWidth / productHeight;
                }

                var diff;
                if (productRatio >= imageRatio) {
                    diff = productRatio - imageRatio;
                } else {
                    diff = imageRatio - productRatio;
                }

                if (diff < bestMatchRatioDiff) {
                    bestMatchRatioDiff = diff;
                    bestMatchProductId = productList[i].getId();
                    bestMatchProductPrintLength = productWidth;
                    bestMatchProductHeight = productHeight;
                }

                if (diff == 0) {
                    break outerLoop;
                }
            }
        }
    return {
        productId: bestMatchProductId,
        productWidth: bestMatchProductPrintLength,
        productHeight: bestMatchProductHeight,
        matchRatioDiff: bestMatchRatioDiff
    };
};

/**
 * Method for calculating how well an image fits a product
 * the method compares the ratio's of the image and product and returns a diff
 * @param {object} image - must contain imageWidth and imageHeight
 * @param {object} product - must contain productWidth and productHeight
 * @return {number} - the ratio match difference between the image and product
 */
ProductCalculations.getProductImageMatch = function (image, product) {
    var productRatio, imageRatio;

    // Calculate the ratios of the image and product
    // Use the "largest" side of the image/product
    productRatio = product.height >= product.width ?
        product.height / product.width :
        product.width / product.height;
    imageRatio = image.height >= image.width ?
        image.height / image.width :
        image.width / image.height;

    var diff = Math.abs(productRatio - imageRatio);
    return diff;
};


/** @TODO improve and refactor
 * Method for calculating the minimum required pixels for an image to achieve the required DPI
 * @return {object} - consisting of the dpi of the image
 */
ProductCalculations.getDPI = function (product, imageWidth, imageHeight, scale) {
    // @TODO fix the issue with productAspect/imageAspect diff when calculating
    if (!scale) scale = 1;
    var inchWidth = product.productWidth / 2.54,
        inchHeight = product.productHeight / 2.54,
        inchDiagonal = Math.sqrt((Math.pow(inchWidth, 2)) + (Math.pow(inchHeight, 2))),
        pxDiagonal = Math.sqrt(Math.pow(imageWidth, 2) + Math.pow(imageHeight, 2)) / scale,
        dpi = pxDiagonal / inchDiagonal;
    return dpi;
};

/**
 * Method for determine if an image is a portrait
 * @param {number} width
 * @param {number} height
 * @param {string} angle
 * @param {string} flip
 * @return {boolean}
 */
ProductCalculations.isPortrait = function (width, height, angle, flip) {
    if (!isNaN(angle) && (angle === 90 || angle === -90 || angle === 270 || angle === -270)) {
        return (width > height);
    }
    else {
        return (width < height);
    }
};

/**
 * There is a special feature, where on the upsell page, one can upgrade
 * a product, f.ex from 10x15 to 20x30, keeping the same ratio, but paying more.
 * Switching product on an item in the product list is no problem, but swithing it
 * on an entire upsell group of items, that creates lots of complications. That's why we need to
 * add the upgrade as an upsell to the product, and wait untill we create the JSON
 * output to switch the product. That way, we can consider it just an upsell and not a product
 * switch. This also means that the enlargement product, 20x30 in this example,
 * needs to have the same upsells and the same prices for the upsells. Marketing
 * has promised that this will never change (haha)..
 *
 * @param {array} productList list of all products that the app has
 */
ProductCalculations.addUpgradeProductAsUpsell = function (productList) {

    //Loop through all the products
    for (var i = 0; i < productList.length; i++) {
        var product = productList[i];

        //Find id of product that this product can be upgraded to
        var upgradeProductId = ProductCalculations.getUpsellProductId(product.getId());
        if (upgradeProductId !== null) { //This product has an upgrade product

            //Load the upgrade product
            var upgradeProduct = ProductStore.getProductById(upgradeProductId);

            if (upgradeProduct) {
                //Loop through every print width that this product has
                for (var width in product.getWidthList()) {

                    //Check if there is a print width on the upgrade product that has the same aspect as the current print width
                    var upgradeProductWidth = ProductCalculations.getProductWidthByAspect(upgradeProduct, width / product.getHeight());

                    if (upgradeProductWidth !== null) {
                        //Create a upsell option for this print width
                        var upsaleOption = {
                            title: _('Enlarge') + ' (' + upgradeProduct.getWidthOptionTitle(upgradeProductWidth) + ')',
                            price: ProductCalculations._getProductPriceDiff(product, upgradeProduct, width, upgradeProductWidth),
                            vendorArticleOptionId: null,
                            visible: false
                        };

                        //Add the option to the product
                        product.addUpsaleOption("upgradeProduct_" + width, upsaleOption);
                    }
                }
            }

        }
    }
};

/**
 * Each item has potential warnings about low resolution
 * and image cropping due to non-matching product format and
 * image format. This function can update the item's warnings
 * based on calculations on the new productHeight and productWidth
 * @param  {OpeOrderItem} item
 * @param  {float} productWidth
 * @param  {float} productHeight
 */
ProductCalculations.updateLowResAndCropWarnings = function (item, productWidth, productHeight) {
    //Reset crop width and height on image
    item.removeCropWidthAndHeight();

    //If the image needs cropping after we switch the product, notify the customer with a crop warning
    var image = ImageStore.getImageById(item.imageId);
    if (image) {
        var imageData = {
                width: image.getWidth(),
                height: image.getHeight()
            },
            productData = {
                width: productWidth,
                height: productHeight
            };

        //Figure out if the image is cropped, and show crop warning if it's cropped
        var matchAspect = ProductCalculations.getProductImageMatch(imageData, productData);
        if (matchAspect > Config.ProductRatioWarning) {
            SelectorActions.setAutoCropWarning(item.getId(), true);
        } else {
            SelectorActions.setAutoCropWarning(item.getId(), false);
        }

        //Figure out if the image needs to have a low res warning
        var newDPI = item.getDPI(1.0);

        if (newDPI < 300) {
            // If the new DPI is below the recommended DPI for prints then add low res warning
            SelectorActions.setLowResWarning(item.getId());
        }
        if (newDPI > 300 && item.getLowResWarning()) {
            SelectorActions.removeLowResWarning(item.getId());
        }
    }
};

/**
 * Find a product width that matches the aspect that is given
 * @param  {OpeProduct} product
 * @param  {float} aspect
 * @return {null|float}
 */
ProductCalculations.getProductWidthByAspect = function (product, aspect) {

    for (var width in product.getWidthList()) {
        var newAspect = width / product.getHeight();

        var diff;
        if (newAspect >= aspect) {
            diff = newAspect - aspect;
        } else {
            diff = aspect - newAspect;
        }
        if (diff <= Config.ProductRatioWarning) {
            return width;
        }
    }
    return null;
};

/**
 * Get the price diff between the two given products
 * @param  {OpeProduct} product
 * @param  {OpeProduct} upgradeProduct
 * @param  {float} width
 * @param  {float} upgradeWidth
 * @return {float}
 */
ProductCalculations._getProductPriceDiff = function (product, upgradeProduct, width, upgradeWidth) {
    var upgradeProductPrice = upgradeProduct.getBasePrice() + upgradeProduct.getWidthOptionPrice(upgradeWidth);
    var productPrice = product.getBasePrice() + product.getWidthOptionPrice(width);

    return upgradeProductPrice - productPrice;
};

/**
 * If the given product has a product defined in the config that it can be
 * upgraded to, then return the id of the upgrade product
 * @param  {string} productId
 * @return {null|string}
 */
ProductCalculations.getUpsellProductId = function (productId) {

    for (var i = 0; i < Config.UpsellProducts.length; i++) {
        if (Config.UpsellProducts[i].from === productId) {
            return Config.UpsellProducts[i].to;
        }
    }
    return null;
};

export default ProductCalculations;
